<!--
 * @Author: cryi.liu
 * @Date: 2020-05-08 15:26:19
 * @LastEditTime: 2020-06-20 14:31:29
 * @Description: 添加题目模态弹框
 -->
<template>
  <i-modal
    class="add-question-product-group-modal"
    :value="show"
    fullscreen
    footer-hide
    title="按产品组组题"
    @on-visible-change="modalShowStateChanged">
    <add-question-by-product-group-step :current="currentStep" />
    <!-- 这里的v-if用来触发重置步骤组件 -->
    <div v-if="show" class="step-item">
      <keep-alive>
        <component
          :is="stepComponent"
          :filter-menu="filterMenu"
          :question-count="questionCount"
          :group-count="groupCount"
          @disabled-done-btn="disabledDoneBtnHandler" />
      </keep-alive>
    </div>
    <add-question-action-bar
      :steps="2"
      :current="currentStep"
      :type="type"
      :done-btn-enable="doneBtnEnable"
      @canel="canelAddQuestionHandler"
      @prev="prevStepHandler"
      @next="nextStepHandler"
      @done="doneStepHandler" />
  </i-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AddQuestionByProductGroupStep from './AddQuestionByProductGroupStep.vue';
import TestQuestionFilterByProductGroup from './TestQuestionFilterByProductGroup.vue';
import AddQuestion from './AddQuestion.vue';
import AddQuestionActionBar from './AddQuestionActionBar.vue';

export default {
  name: 'AddQuestionByProductGroupModal',
  components: {
    AddQuestionByProductGroupStep,
    AddQuestionActionBar,
  },
  data() {
    return {
      currentStep: 0,
      stepComponent: TestQuestionFilterByProductGroup,
      filterMenu: {},
      questionCount: {},
      groupCount: {},
      doneBtnEnable: true,
    };
  },
  computed: {
    ...mapGetters({
      token: 'authStore/token',
      type: 'createPaperStore/addQuestionByProductGroupModalType',
      show: 'createPaperStore/addQuestionByProductGroupModalShow',
      addBigQuestionRule: 'createPaperStore/addBigQuestionRule',
    }),
  },
  watch: {
    currentStep(value) {
      switch (value) {
        case 0:
          this.stepComponent = TestQuestionFilterByProductGroup;
          break;
        case 1:
          this.stepComponent = AddQuestion;
          break;
        default:
          break;
      }
    },
    show(state) {
      if (state) {
        this.requestFilterMenuListAndSetting();
      } else {
        this.resetAddBigQuestionRule();
        this.setComQuestionType({ comQuestionType: '' });
        this.setAddQuestionByProductGroupModalType({ type: '' });
      }
    },
  },
  methods: {
    ...mapActions({
      setAddQuestionByProductGroupModalType: 'createPaperStore/invokeSetAddQuestionByProductGroupModalType',
      setAddQuestionByProductGroupModalShow: 'createPaperStore/invokeSetAddQuestionByProductGroupModalShow',
      setComQuestionType: 'createPaperStore/invokeSetComQuestionType',
      resetAddBigQuestionRule: 'createPaperStore/invokeResetAddBigQuestionRule',
      setAddBigQuestionRuleOfGroupCodeMap: 'createPaperStore/invokeSetAddBigQuestionRuleOfGroupCodeMap',
      setBigQuestions: 'createPaperStore/invokeSetBigQuestions',
    }),
    /**
     * 模态框显示状态改变处理函数
     */
    modalShowStateChanged(show) {
      this.setAddQuestionByProductGroupModalShow({ show });

      if (!show) {
        this.currentStep = 0;
      }
    },
    /**
     * 取消添加大类或题目处理函数
     */
    canelAddQuestionHandler() {
      this.groupCount = {};
      this.setAddBigQuestionRuleOfGroupCodeMap({ groupCodeMap: this.groupCount });
      this.setAddQuestionByProductGroupModalShow({ show: false });
    },
    /**
     * 上一步处理函数
     */
    prevStepHandler() {
      this.currentStep -= 1;

      if (this.currentStep === 0) {
        this.groupCount = {};
        this.setAddBigQuestionRuleOfGroupCodeMap({ groupCodeMap: {} });
        this.doneBtnEnable = true;
      }
    },
    /**
     * 下一步处理函数
     */
    nextStepHandler() {
      if (this.addBigQuestionRule.years.length === 0) {
        alert('未选择年份筛选条件');
        return;
      }

      if (this.addBigQuestionRule.levels.length === 0) {
        alert('未选择难易度筛选条件');
        return;
      }

      if (this.addBigQuestionRule.libraryTypes.length === 0) {
        alert('未选择题库类型筛选条件');
        return;
      }
      this.currentStep += 1;

      this.reuqestQuestionCountAndSetting();
    },
    /**
     * 禁止点击完成按钮
     */
    disabledDoneBtnHandler() {
      this.doneBtnEnable = false;
    },
    /**
     * 完成处理函数
     */
    doneStepHandler() {
      const groupCount = JSON.parse(JSON.stringify(this.groupCount));
      let flag = false;

      Object.keys(this.groupCount).forEach((key) => {
        if (groupCount[key] !== 0) {
          flag = true;
        } else {
          delete groupCount[key];
        }
      });

      if (flag) {
        this.setAddBigQuestionRuleOfGroupCodeMap({ groupCodeMap: groupCount });

        if (this.type === 'add') {
          this.requestDoneBigQuestionAndSetting();
        } else if (this.type === 'update') {
          this.requestDoneUpdateQuestionAndSetting();
        }
      } else {
        alert('未添加选题');
      }
    },
    /**
     * 请求筛选目录列表并设置
     */
    requestFilterMenuListAndSetting() {
      this.requestFilterMenuList()
        .then((result) => {
          this.filterMenu = result;
        })
        .catch((result) => {
          alert(result.msg);
        });
    },
    /**
     * 请求筛选目录列表
     */
    requestFilterMenuList() {
      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.libraryFilterMenu();

        if (result.code === '200') {
          resolve(result.data);
        } else {
          reject(result);
        }
      });
    },
    /**
     * 请求符合筛选条件产品组及对应题数并设置
     */
    reuqestQuestionCountAndSetting() {
      this.reuqestQuestionCount()
        .then((result) => {
          this.questionCount = result;
        })
        .catch((result) => {
          alert(result.msg);
        });
    },
    /**
     * 请求符合筛选条件产品组及对应题数
     */
    reuqestQuestionCount() {
      const params = {
        paperId: this.addBigQuestionRule.paperId,
        questionType: this.addBigQuestionRule.questionType,
        years: this.addBigQuestionRule.years.join(','),
        level: this.addBigQuestionRule.levels.join(','),
        libraryTypes: this.addBigQuestionRule.libraryTypes.join(','),
        productNames: this.addBigQuestionRule.productNames.join(','),
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.paperCreateQuestionCount(params);

        if (result.code === '200') {
          resolve(result.data);
        } else {
          reject(result);
        }
      });
    },
    /**
     * 请求完成试题大类组题并设置
     */
    requestDoneBigQuestionAndSetting() {
      this.requestDoneBigQuestion()
        .then((result) => {
          alert('添加题目大类成功');

          this.groupCount = {};
          this.setBigQuestions({ bigQuestions: result.result });
          this.setAddQuestionByProductGroupModalShow({ show: false });
        })
        .catch((result) => {
          alert(result.msg);
        });
    },
    /**
     * 请求完成试题大类组题
     */
    requestDoneBigQuestion() {
      const params = {
        isRequiredQuestion: false,
        paperLibraryFlag: 'GROUP',
        paperId: this.addBigQuestionRule.paperId,
        questionType: this.addBigQuestionRule.questionType,
        years: this.addBigQuestionRule.years,
        levels: this.addBigQuestionRule.levels,
        libraryTypes: this.addBigQuestionRule.libraryTypes,
        productNames: this.addBigQuestionRule.productNames,
        groupCodeMap: this.addBigQuestionRule.groupCodeMap,
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.paperCreateAddBigQuestion(params);

        if (result.code === '200') {
          resolve(result.data);
        } else {
          reject(result);
        }
      });
    },
    /**
     * 请求完成更新大类小题并设置
     */
    requestDoneUpdateQuestionAndSetting() {
      this.requestDoneUpdateQuestion()
        .then((result) => {
          alert('添加题目成功');

          this.groupCount = {};
          this.setBigQuestions({ bigQuestions: result.result });
          this.setAddQuestionByProductGroupModalShow({ show: false });
        })
        .catch((result) => {
          alert(result.msg);
        });
    },
    /**
     * 请求完成更新大类小题
     */
    requestDoneUpdateQuestion() {
      const params = {
        partId: this.addBigQuestionRule.partId,
        paperLibraryFlag: 'GROUP',
        paperId: this.addBigQuestionRule.paperId,
        questionType: this.addBigQuestionRule.questionType,
        years: this.addBigQuestionRule.years,
        levels: this.addBigQuestionRule.levels,
        libraryTypes: this.addBigQuestionRule.libraryTypes,
        productNames: this.addBigQuestionRule.productNames,
        groupCodeMap: this.addBigQuestionRule.groupCodeMap,
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.paperCreateUpdateBigQuestion(params);

        if (result.code === '200') {
          resolve(result.data);
        } else {
          reject(result);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.add-question-product-group-modal {
  .step-item {
    display: flex;
    justify-content: center;
    margin: 36px 0;
  }
}
</style>
